var _circle, _circle2, _circle3, _circle4, _circle5, _g, _path, _path2, _g2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 118,
    viewBox: "0 0 153 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 58,
    r: 52,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 25,
    r: 5,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 109,
    r: 7,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 41,
    r: 7,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 14,
    r: 4,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_55383_572700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.5 88.1277H41.5L51.7167 16.8404H101.291L111.5 88.1277Z",
    fill: "#EEF0F4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.291 16.8322L93.5099 88.1359H111.5L101.291 16.8322Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0418 21.8257L63.1227 21.2107C63.1227 21.1533 64.4019 15.1594 65.763 9.10811C67.2717 2.35984 73.9052 -0.731402 79.4481 0.145956C84.9911 1.02331 88.1397 5.31171 87.5657 11.0432C86.8442 18.2261 86.2948 21.6207 86.2784 21.7601L83.3348 21.2845C83.3348 21.2845 83.8841 17.8243 84.5975 10.748C85.2125 4.59013 80.4485 3.3274 78.9726 3.08961C74.7908 2.40904 69.7972 4.72954 68.6657 9.7641C67.3209 15.7908 66.05 21.7683 66.0418 21.8257Z",
    fill: "#D9DEE9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.6487 87.9064L94.2715 87.2668L103.619 81.8715L110.966 87.275L110.523 87.8736L103.57 82.757L94.6487 87.9064Z",
    fill: "#6B83B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.127 27.6738L101.381 27.6992L103.241 82.3179L103.986 82.2925L102.127 27.6738Z",
    fill: "#6B83B9"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5505 21.5224C67.5489 22.1091 67.3735 22.6821 67.0463 23.1692C66.7192 23.6562 66.255 24.0354 65.7125 24.2588C65.17 24.4822 64.5734 24.5398 63.9982 24.4244C63.4229 24.3089 62.8948 24.0256 62.4805 23.6101C62.0662 23.1947 61.7843 22.6658 61.6705 22.0902C61.5566 21.5147 61.6159 20.9183 61.8408 20.3764C62.0657 19.8345 62.4461 19.3714 62.934 19.0456C63.422 18.7198 63.9956 18.5459 64.5823 18.5459C64.9728 18.5459 65.3594 18.623 65.7201 18.7726C66.0807 18.9223 66.4083 19.1417 66.6841 19.4182C66.9598 19.6947 67.1783 20.0229 67.3269 20.3839C67.4756 20.745 67.5516 21.1319 67.5505 21.5224Z",
    fill: "#D9DEE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.55 21.5224C87.55 22.111 87.3754 22.6865 87.0484 23.176C86.7213 23.6655 86.2565 24.047 85.7126 24.2722C85.1687 24.4975 84.5703 24.5565 83.9929 24.4416C83.4155 24.3268 82.8852 24.0433 82.4689 23.627C82.0526 23.2108 81.7691 22.6804 81.6543 22.103C81.5395 21.5257 81.5984 20.9272 81.8237 20.3833C82.049 19.8395 82.4305 19.3746 82.9199 19.0475C83.4094 18.7205 83.9849 18.5459 84.5736 18.5459C85.363 18.5459 86.12 18.8595 86.6782 19.4177C87.2364 19.9759 87.55 20.733 87.55 21.5224Z",
    fill: "#D9DEE9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_55383_572700",
    x: 30.4474,
    y: 9.47197,
    width: 92.1053,
    height: 93.3926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.68421
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.52632
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.690196 0 0 0 0 0.745098 0 0 0 0 0.772549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55383_572700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55383_572700",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreEmpty);
export default __webpack_public_path__ + "static/media/store-empty.77960ca553e36b0c57ba2b7880488f85.svg";
export { ForwardRef as ReactComponent };